export class DictionaryReader {
  readXMLConfig = (dictionaryConfig, dictionaryXML) => {};
}
